// src/components/business-playbook/VideoPlaceholder.js
import React from 'react';

const VideoPlaceholder = () => (
  <div style={{
    position: 'relative',
    width: '100%',
    paddingBottom: '56.25%',
    border: '2px dashed #d1d5db',
    borderRadius: '8px',
    backgroundColor: '#f9fafb',
    marginBottom: '24px',
    overflow: 'hidden'
  }}>
    <div style={{
      position: 'absolute',
      top: 0, left: 0, right: 0, bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px'
    }}>
      <div style={{
        width: '56px',
        height: '56px',
        borderRadius: '50%',
        border: '2px solid #d1d5db',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <svg width="20" height="24" viewBox="0 0 20 24" fill="none">
          <path d="M2 1.5L18 12L2 22.5V1.5Z" fill="#9ca3af" />
        </svg>
      </div>
      <span style={{
        fontSize: '14px',
        fontWeight: 500,
        color: '#6b7280',
        fontFamily: 'Montserrat, sans-serif'
      }}>
        Video coming soon
      </span>
    </div>
  </div>
);

export default VideoPlaceholder;
